<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="innerVisible"
    width="780px"
    append-to-body
    destroy-on-close
    :close-on-click-modal="false"
    custom-class="parent-voip-auth-dialog"
    @open="loadList"
  >
    <div v-loading="loading">
      <el-alert
        v-if="showSubscribeHint"
        type="info"
        :closable="false"
        show-icon
        :title="subscribeHintTitle"
        style="margin-bottom: 12px"
      />
      <div class="parent-voip-auth-summary">
        <div>
          监护人：<strong>{{ parentName || '-' }}</strong>
          （学生：<strong>{{ studentName || '-' }}</strong>）
        </div>
        <el-tag v-if="relationDesc" size="mini" type="primary">{{ relationDesc }}</el-tag>
      </div>
      <el-table :data="list" border stripe size="small" empty-text="当前学校暂无启用的话机分组">
        <el-table-column label="公话分组名称" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ pick(scope.row, 'GroupName', 'groupName') || '-' }}</template>
        </el-table-column>
        <el-table-column label="分组说明" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ pick(scope.row, 'Description', 'description') || '-' }}</template>
        </el-table-column>
        <el-table-column label="订阅状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="isAuthorized(scope.row) ? 'success' : 'info'" size="small" effect="plain">
              {{ isAuthorized(scope.row) ? '已订阅' : '未订阅' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="订阅 OpenId" min-width="170" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="pick(scope.row, 'OpenId', 'openId')" class="openid-text">
              {{ pick(scope.row, 'OpenId', 'openId') }}
            </span>
            <span v-else class="text-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="最后订阅时间" width="170" align="center">
          <template slot-scope="scope">
            <span v-if="formatTime(pick(scope.row, 'LastSubscribeTime', 'lastSubscribeTime')) !== '-'">
              {{ formatTime(pick(scope.row, 'LastSubscribeTime', 'lastSubscribeTime')) }}
            </span>
            <span v-else class="text-muted">—</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer">
      <el-button @click="innerVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCommVoipParentVoipGroups } from '../../../api/modules/misc'
import { normalizeDeptId } from '../../../utils/deptCascaderProps'

export default {
  name: 'ParentVoipAuthDialog',
  props: {
    visible: { type: Boolean, default: false },
    parentId: { type: [Number, String], default: 0 },
    departmentId: { type: [Number, String], default: 0 },
    parentName: { type: String, default: '' },
    studentName: { type: String, default: '' },
    relationDesc: { type: String, default: '' },
    wxBound: { type: Boolean, default: false },
    voipAuthCount: { type: Number, default: 0 }
  },
  data() {
    return {
      loading: false,
      list: []
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    dialogTitle() {
      return this.parentName ? `话机分组订阅状态 — 监护人：${this.parentName}` : '话机分组订阅状态'
    },
    showSubscribeHint() {
      return !this.wxBound || Number(this.voipAuthCount) <= 0
    },
    subscribeHintTitle() {
      if (!this.wxBound) {
        return '该监护人尚未绑定微信，请先完成微信绑定后再在家长端订阅话机分组'
      }
      return '请家长在小程序 / 家长端完成话机分组订阅'
    }
  },
  methods: {
    pick(row, ...keys) {
      if (!row) return ''
      for (let i = 0; i < keys.length; i++) {
        const v = row[keys[i]]
        if (v != null && v !== '') return v
      }
      return ''
    },
    isAuthorized(row) {
      return !!(row && (row.IsAuthorized || row.isAuthorized))
    },
    formatTime(val) {
      if (!val) return '-'
      const s = String(val).replace('T', ' ')
      return s.length >= 19 ? s.slice(0, 19) : s
    },
    /** 加载本校全部 VOIP 组及订阅状态。最后更新：2026-08-30 */
    async loadList() {
      const parentId = Number(this.parentId || 0)
      const departmentId = normalizeDeptId(this.departmentId)
      if (!parentId || !departmentId) {
        this.list = []
        return
      }
      this.loading = true
      try {
        const res = await getCommVoipParentVoipGroups({ parentId, departmentId })
        if (res.data.success) {
          this.list = res.data.response || []
        } else {
          this.$message.error(res.data.msg || '加载话机分组失败')
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.parent-voip-auth-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  padding: 10px 14px;
  font-size: 13px;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.openid-text {
  font-family: monospace;
  font-size: 12px;
  color: #334155;
}
.text-muted {
  color: #94a3b8;
}
</style>
<style>
.parent-voip-auth-dialog .el-dialog__body {
  padding: 20px 20px 24px;
}
</style>
